import { render, staticRenderFns } from "./ClassicInput.vue?vue&type=template&id=b09ce4c2"
import script from "./ClassicInput.vue?vue&type=script&lang=js"
export * from "./ClassicInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports